export const isPageVisible = () => document.visibilityState === 'visible';
